export class FinancialVendorAddress {
    public id: number
    public locationCode: string;
    public isActive: boolean;
    public isPrimary: boolean;
    public address1: string;
    public address2: string;
    public address3: string;
    public address4: string;
    public city: string;
    public stateProvince: string;
    public postalCode: string;
}
